module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_06-e617f69de867b4213f7d65de923a6aea.png";